export default "__VITE_ASSET__sh2Mzyhg__"